"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverlappedMainPipeHandler_banished = exports.OverlappedMainPipeHandler = void 0;
const pipeNode_1 = require("../pipeNode");
const LineSegment_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/LineSegment.js"));
class OverlappedMainPipeHandler {
    handle(pipeNodeGroup, nodeOnMainPipe, linkNode) {
        var _a;
        let mainNodes = new Array();
        for (let mainNode of pipeNodeGroup._mainPipeNodes) {
            this.getMainNodes(mainNode, mainNodes, pipeNodeGroup);
        }
        if (mainNodes.length < 2)
            return;
        let overlapMainNodes = [];
        let oldNode; //原来的连接到linkNode或者主管线的节点
        let linkSegment = new LineSegment_js_1.default(nodeOnMainPipe._point, linkNode._point);
        //是否有某段覆盖主管线连线的连线比与主管线连线长
        let longerOverlapSegment;
        for (let mainNode of mainNodes) {
            if (mainNode == linkNode) {
                oldNode = mainNode;
                continue;
            }
            if (mainNode._parent == linkNode && mainNodes.indexOf(mainNode._parent) < 0) {
                oldNode = mainNode;
            }
            let segment = new LineSegment_js_1.default(mainNode._point, mainNode._parent._point);
            let overlapResult = this.isTwoSegmentOverlap(linkSegment, segment);
            if (overlapResult === OverLapResult.FirstOverlapSecond) {
                overlapMainNodes.push(mainNode);
            }
            else if (overlapResult === OverLapResult.SecondOverlapFirst) {
                overlapMainNodes.push(mainNode);
                longerOverlapSegment = [mainNode._parent, mainNode];
            }
        }
        if (!oldNode || overlapMainNodes.length == 0)
            return;
        overlapMainNodes.push(oldNode);
        //区分是否存在expandNode的情况
        if (linkNode == oldNode) {
            //如果不存在expandNode，则将linkNode指向主管线上的点
            linkNode = linkNode._parent;
        }
        if (!longerOverlapSegment) {
            overlapMainNodes.sort(function (a, b) { return linkNode._point.distance(a._point) - linkNode._point.distance(b._point); });
            for (let node of overlapMainNodes) {
                (_a = node._parent) === null || _a === void 0 ? void 0 : _a.removeChildNode(node);
            }
            linkNode.addChildNode(overlapMainNodes[0]);
            for (let i = 1; i < overlapMainNodes.length; i++) {
                overlapMainNodes[i - 1].addChildNode(overlapMainNodes[i]);
            }
        }
        else {
            //理论上来说linkNode在longerOverlapSegment上
            longerOverlapSegment[0].removeChildNode(longerOverlapSegment[1]);
            linkNode.addChildNode(longerOverlapSegment[0]);
            linkNode.addChildNode(longerOverlapSegment[1]);
        }
    }
    getMainNodes(node, mainNodes, pipeNodeGroup) {
        this.traverseToGetMainNodes(node, mainNodes, pipeNodeGroup);
        return mainNodes;
    }
    traverseToGetMainNodes(node, mainNodes, pipeNodeGroup) {
        if (node._type == pipeNode_1.PipeNodeType.Main && mainNodes.indexOf(node) < 0) {
            mainNodes.push(node);
        }
        if (pipeNodeGroup._mainPipeNodes.indexOf(node) < 0) //多组相连的，只向下探一层
            return;
        for (let child of node._children) {
            if (child._type != pipeNode_1.PipeNodeType.Main)
                continue;
            this.traverseToGetMainNodes(child, mainNodes, pipeNodeGroup);
        }
    }
    isTwoSegmentOverlap(seg1, seg2) {
        let firstLonger = seg1.getLength() > seg2.getLength();
        let longerSeg = firstLonger ? seg1 : seg2;
        let shorterSeg = firstLonger ? seg2 : seg1;
        let isOverlap = longerSeg.distance(shorterSeg.p0) < 1 && longerSeg.distance(shorterSeg.p1) < 1;
        if (!isOverlap) {
            return OverLapResult.None;
        }
        else {
            if (firstLonger)
                return OverLapResult.FirstOverlapSecond;
            else
                return OverLapResult.SecondOverlapFirst;
        }
    }
}
exports.OverlappedMainPipeHandler = OverlappedMainPipeHandler;
class OverlappedMainPipeHandler_banished {
    handle(pipeNodeGroups, mainPipeNodes) {
        let mainPipeInfos = new Array();
        for (let pipeNodeGroup of pipeNodeGroups) {
            let mainPipeInfo = this.getMainPipe(pipeNodeGroup, mainPipeNodes);
            mainPipeInfos.push(mainPipeInfo);
        }
        let handled = new Array(pipeNodeGroups.length).fill(false);
        for (let i = 0; i < pipeNodeGroups.length; i++) {
            if (handled[i] || !mainPipeInfos[i])
                continue;
            let mainPipeInfo = mainPipeInfos[i];
            for (let j = 0; j < pipeNodeGroups.length; j++) {
                if (handled[i] || handled[j] || i == j || !mainPipeInfos[j])
                    continue;
                let otherMainPipeInfo = mainPipeInfos[j];
                //判断两组线段是否有重叠
                for (let mainPipe of mainPipeInfo._mainPipes) {
                    let alreadyHandled = false;
                    for (let otherMainPipe of otherMainPipeInfo._mainPipes) {
                        let overlapResult = this.isTwoSegmentOverlap(mainPipe, otherMainPipe);
                        if (overlapResult === OverLapResult.None)
                            continue;
                        else if (overlapResult === OverLapResult.FirstOverlapSecond) {
                            this.handleOne(mainPipe, otherMainPipe, mainPipeInfo, otherMainPipeInfo);
                        }
                        else {
                            this.handleOne(otherMainPipe, mainPipe, otherMainPipeInfo, mainPipeInfo);
                        }
                        alreadyHandled = true;
                        break;
                    }
                    if (alreadyHandled) {
                        handled[i] = true;
                        handled[j] = true;
                        break;
                    }
                }
            }
        }
    }
    handleOne(mainPipe1, mainPipe2, mainPipeInfo1, mainPipeInfo2) {
        //1.计算交点
        //mainPipe1覆盖mainPipe2
        //只处理有一个点在线段中间的情况
        let on_p0 = mainPipe2.p0.equals2D(mainPipe1.p0, 0.1) || mainPipe2.p0.equals2D(mainPipe1.p1, 0.1);
        let on_p1 = mainPipe2.p1.equals2D(mainPipe1.p0, 0.1) || mainPipe2.p1.equals2D(mainPipe1.p1, 0.1);
        if (on_p0 == on_p1)
            return;
        //2.判断父子关系
        let node1 = this.findNode(mainPipe1.p0, mainPipeInfo1._mainNodes);
        let node2 = this.findNode(mainPipe1.p1, mainPipeInfo1._mainNodes);
        let node3 = this.findNode(on_p0 ? mainPipe2.p0 : mainPipe2.p1, mainPipeInfo2._mainNodes);
        //选出涉及的节点里的父节点
        let pNodes1 = this.getAllParentNodes(node1);
        let pNodes2 = this.getAllParentNodes(node2);
        let pNodes3 = this.getAllParentNodes(node3);
        //3.相连
        //都连到父节点上
        if (pNodes2.indexOf(node1) && pNodes3.indexOf(node1)) { //node1为父节点
            node2._parent.removeChildNode(node2);
            node3._parent.removeChildNode(node3);
            node1.addChildNode(node3);
            node3.addChildNode(node2);
        }
        else if (pNodes1.indexOf(node2) && pNodes3.indexOf(node2)) { //node2为父节点
            node1._parent.removeChildNode(node1);
            node3._parent.removeChildNode(node3);
            node2.addChildNode(node3);
            node3.addChildNode(node1);
        }
        else if (pNodes1.indexOf(node3) && pNodes1.indexOf(node3)) { //node3为父节点
            node1._parent.removeChildNode(node1);
            node2._parent.removeChildNode(node2);
            node3.addChildNode(node1);
            node3.addChildNode(node2);
        }
        else { //异常情况
            console.log("主管线覆盖的异常情况");
            return;
        }
    }
    getMainPipe(pipeNodeGroup, nodeOnMainPipes) {
        if (pipeNodeGroup._mainPipeNodes.length == 0)
            return null;
        let mainPipes = new Array();
        let mainNodes = new Array();
        //第一个节点一般就是整组的主节点
        let mainNode = pipeNodeGroup._mainPipeNodes[0];
        let currentNode = mainNode;
        while (nodeOnMainPipes.indexOf(currentNode) < 0) {
            mainPipes.push(new LineSegment_js_1.default(currentNode._point, currentNode._parent._point));
            mainNodes.push(currentNode);
            currentNode = currentNode._parent;
        }
        return new MainPipeInfo(mainPipes, mainNodes);
    }
    isTwoSegmentOverlap(seg1, seg2) {
        let firstLonger = seg1.getLength() > seg2.getLength();
        let longerSeg = firstLonger ? seg1 : seg2;
        let shorterSeg = firstLonger ? seg2 : seg1;
        let isOverlap = longerSeg.distance(shorterSeg.p0) < 1 && longerSeg.distance(shorterSeg.p1) < 1;
        if (!isOverlap) {
            return OverLapResult.None;
        }
        else {
            if (firstLonger)
                return OverLapResult.FirstOverlapSecond;
            else
                return OverLapResult.SecondOverlapFirst;
        }
    }
    findNode(point, nodes) {
        for (let node of nodes) {
            if (node._point.equals2D(point)) {
                return node;
            }
        }
        debugger;
        throw new Error("计算管线重叠时没有找到主节点");
    }
    getAllParentNodes(node) {
        let nodes = [node];
        let currentNode = node;
        while (currentNode._parent) {
            currentNode = currentNode._parent;
            nodes.push(currentNode);
        }
        return nodes;
    }
}
exports.OverlappedMainPipeHandler_banished = OverlappedMainPipeHandler_banished;
class MainPipeInfo {
    constructor(mainPipes, mainNodes) {
        this._mainPipes = mainPipes;
        this._mainNodes = mainNodes;
    }
}
var OverLapResult;
(function (OverLapResult) {
    OverLapResult[OverLapResult["None"] = 0] = "None";
    OverLapResult[OverLapResult["FirstOverlapSecond"] = 1] = "FirstOverlapSecond";
    OverLapResult[OverLapResult["SecondOverlapFirst"] = 2] = "SecondOverlapFirst";
})(OverLapResult || (OverLapResult = {}));
